import { render, staticRenderFns } from "./PendingAwardsTable.vue?vue&type=template&id=eda883ae"
import script from "./PendingAwardsTable.vue?vue&type=script&lang=js"
export * from "./PendingAwardsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports